import { BenchEmployeeDelegate } from "../BenchEmployeeService/bench-employee.delegate"
import { BenchEmployeeService } from "../BenchEmployeeService/bench-employee.service"
import { HttpProviderFactory } from '../http/http-provider.factory';
import { SpinnerService } from '../SpinnerService/spinner.service';
import { IAppConfig } from '../http/types/IApplicationConfig';
import { AuthenticationService } from '../AuthenticationService/authentication.service';

export class BenchEmployeeServiceFactory
{
    static create(config: IAppConfig, spinnerService?: SpinnerService,
        authenticationService?: AuthenticationService
    ): BenchEmployeeService
    {
        const httpProvider = HttpProviderFactory.createHttpProvider(config, spinnerService);
        const delegate = new BenchEmployeeDelegate(config, httpProvider);

        return new BenchEmployeeService(delegate, authenticationService);
    }
}